export function uiSrefDirective() {
	return {
		restrict: 'A',
		scope: false,
		controller: uiSrefDirectiveCtrl,
	};
}

/**
 * Same functionality as ui-router's ui-sref except
 * this plays nice with UrlDataService because
 * this sets href before transitioning to new state
 */
export class uiSrefDirectiveCtrl {
	constructor($scope, $element, $attrs, $state, $window) {
		'ngInject';
		const buildHref = () => {
			// first extract state name from passed parameters
			const [stateOrName, paramsString] = uiSrefDirectiveCtrl.parseSref($attrs.uiSref);
			// evaluate parameters inside current scope
			const params = $scope.$eval(paramsString);
			// evaluate options if any
			const options = $attrs.uiSrefOpts ? $scope.$eval($attrs.uiSrefOpts) : {};
			// build the final href
			const href = $state.href(stateOrName, params, options);
			if (!href) {
				console.error('Unable to resolve ui-sref `' + $attrs.uiSref + '`');
				return '';
			}
			return href;
		};
		const isLink = $element[0].tagName.toUpperCase() == 'A';
		if (isLink) {
			// make sure A elements appear clickable
			// and allow them to open new tabs on middle click
			$element.attr('href', buildHref());
		}
		$element.on('click', evt => {
			// go to the new href
			// for A elements, go on left click only
			if (!isLink || evt.button === 0) {
				// prevent href action and rebuild href just in case scope vars change
				evt.preventDefault();
				$window.location.href = buildHref();
			}
		});
	}

	static parseSref(sref) {
		let match;
		if (sref.match(/^\{.*\}$/)) {
			// current state with new args: e.g. {id: 4}
			return ['', sref];
		} else if ((match = sref.match(/^([^(]+)\s*\((.*)\)\s*$/))) {
			// function style: e.g. hub.loggedin.DoStuff({id: 4})
			return [match[1], match[2] || '{}'];
		} else {
			// just a string: e.g. hub.loggedin.DoStuff
			return [sref, '{}'];
		}
	}
}
